import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import InputTextField from '../../../../../component/input/inputTextField';
import FilterSelect from '../../../../../component/select/filterSelect';
import { MenuItem, Typography } from '@mui/material';

import { FiscalYearApi, updateFiscalYear } from '../../../../../api/fiscal-year/fiscalyear.api';
import { ButtonContained } from '../../../../../component/mui-custom/MuiCustom';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../../store/slice/loading/loading.slice';
import { swalError, swalSuccess } from '../../../../../component/notification/swal';

type Props = {
    fetchData: () => void;
    toggleModal: () => void;
    fiscalYearId: number;
}

const EditFiscalYear: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [fiscalYear, setFiscalYear] = useState<updateFiscalYear>({
        fiscalYear: "",
        fiscalYearStatus: t("STATUS.ACTIVE")
    })

    // API
    const handleGetFiscalYearDetail = async () => {
        dispatch(setLoading())
        await FiscalYearApi.getDetailFiscalYear(props.fiscalYearId)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    const { fiscalYear, fiscalYearStatus } = res.data?.result
                    setFiscalYear((prev) => ({ ...prev, fiscalYear: fiscalYear, fiscalYearStatus: fiscalYearStatus }))
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }
    const handleSubmit = async (event: React.FormEvent) => {
        dispatch(setLoading())
        event.preventDefault();
        await FiscalYearApi.updateFiscalYear(props.fiscalYearId, fiscalYear)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    swalSuccess(res.data?.description)
                    props.fetchData()
                    props.toggleModal()
                } else {
                    dispatch(unsetLoading())
                    swalError(res.response?.data?.description)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                swalError(error.response?.data?.description)
                console.log(error)
            })
    }

    useEffect(() => {
        handleGetFiscalYearDetail()
    }, [])
    return (
        <form className='w-full' onSubmit={handleSubmit}>
            <div className='flex flex-col w-full mt-8 gap-5'>
                <span>
                    <InputTextField
                        required
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setFiscalYear((prev) => ({ ...prev, fiscalYear: e.target.value }))}
                        value={fiscalYear.fiscalYear}
                        heading='ปีงบประมาณ'
                    />
                </span>
                <span>
                    <FilterSelect
                        required
                        heading={t("สถานะ")}
                        renderValue={() => fiscalYear.fiscalYearStatus === t("STATUS.ACTIVE") ?
                            <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            : <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>}
                        label={t('STATUS.LABEL')}
                        selectId="select-fiscal-year"
                        value={fiscalYear.fiscalYearStatus}
                        labelId="label-fiscal-year"
                        onchange={(event: React.ChangeEvent<HTMLSelectElement>) => setFiscalYear((prev) => ({ ...prev, fiscalYearStatus: event.target.value }))}
                        options={[
                            <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            </MenuItem>,
                            <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>
                            </MenuItem>
                        ]}
                    />
                </span>
                <span className='mt-3 flex justify-center items-center'>
                    <ButtonContained
                        type='submit'
                        sx={{ maxWidth: 105 }}
                    >
                        {t("BUTTON.SUBMIT")}
                    </ButtonContained>
                </span>
            </div>
        </form>
    )
}

export default EditFiscalYear